"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCompDBInfoList;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _fetch = _interopRequireDefault(require("./fetch"));
var _conts = require("./conts");
var _logger = _interopRequireDefault(require("../utils/logger"));
var _parse = _interopRequireDefault(require("../utils/parse"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var COMPONENT_HUB_PATH = 'componenthub';

/**
   * 获取组件商店DB的组件信息列表
   */
function getCompDBInfoList() {
  return _getCompDBInfoList.apply(this, arguments);
}
function _getCompDBInfoList() {
  _getCompDBInfoList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var dbUrl,
      queryObject,
      env,
      query,
      url,
      result,
      componentArray,
      _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dbUrl = _args.length > 0 && _args[0] !== undefined ? _args[0] : "".concat(_conts.BASE_API_PATH, "/").concat(COMPONENT_HUB_PATH);
          queryObject = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          env = queryObject.projectEnv; // eslint-disable-next-line no-param-reassign
          delete queryObject.projectEnv; // 清理掉query的projectEnv
          query = new URLSearchParams(queryObject).toString(); // 遵守统一的规范，通过/env/:envId/的方式传递项目环境
          url = env ? "".concat(_conts.BASE_API_PATH, "/env/").concat(env, "/").concat(COMPONENT_HUB_PATH) : dbUrl;
          _context.prev = 6;
          result = null; // 运行时的页面会直接将商店接口注入到window上，所以这里直接调用
          if (!window.xy_runtime_component_hub) {
            _context.next = 12;
            break;
          }
          result = window.xy_runtime_component_hub;
          _context.next = 15;
          break;
        case 12:
          _context.next = 14;
          return (0, _fetch["default"])("".concat(url, "?").concat(query), {
            method: 'GET'
          });
        case 14:
          result = _context.sent;
        case 15:
          _logger["default"].info('componentHub result', result);
          if (!(result && result.code === 200)) {
            _context.next = 22;
            break;
          }
          componentArray = [];
          (result.data || []).forEach(function (item) {
            if (!item.components) {
              return;
            }
            item.components.forEach(function ($comp) {
              var comp = $comp;
              comp.registry = item.registry;
              comp.group = item.group;
            });
            componentArray = componentArray.concat(item.components);
          });
          componentArray = componentArray.map(function (item) {
            var _item$info, _item$info2;
            // 测试代码，屏蔽老的组件模式
            var isNew = /^(public-|local-)/.test(item.info.id);
            if (!isNew) {
              return undefined;
            }
            return _objectSpread(_objectSpread({}, item.info), {}, {
              category: item.category,
              registry: item.registry,
              group: item.group,
              editorOnly: item.editorOnly,
              demo: item.demo,
              lazyLoad: item.lazyLoad,
              extraInfo: (0, _parse["default"])((_item$info = item.info) === null || _item$info === void 0 ? void 0 : _item$info.extraInfo),
              dependencies: (0, _parse["default"])((_item$info2 = item.info) === null || _item$info2 === void 0 ? void 0 : _item$info2.dependencies)
            });
          }).filter(function (item) {
            return !!item;
          });
          ;
          // 实际上db的数据只有registry、group、id才会被使用，其他的信息有组件内部自己管理(component.js)
          return _context.abrupt("return", componentArray);
        case 22:
          _logger["default"].error('%c wujiComp componenthub db request failed!', 'color: red;', result);
          return _context.abrupt("return", []);
        case 26:
          _context.prev = 26;
          _context.t0 = _context["catch"](6);
          _logger["default"].error('%c wujiComp componenthub db request failed!', 'color: red;', _context.t0);
          return _context.abrupt("return", []);
        case 30:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[6, 26]]);
  }));
  return _getCompDBInfoList.apply(this, arguments);
}